<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-col xs12>
        <v-card>
          <v-card-title primary-title>
            Profile
            <v-spacer></v-spacer>
            <v-btn color="primary" text small outlined @click="signout"
              >signout</v-btn
            >
          </v-card-title>
          <v-card-text class="pt-4">
            <v-layout row>
              <v-flex xs12>
                <div class="title">
                  {{ user.firstName }} {{ user.lastName }}
                </div>
                <p class="mb-0">{{ user.role }}</p>
                <p class="mb-0">{{ user.email }}</p>
              </v-flex>
              <v-flex xs12 md6>
                <v-form v-model="phoneValid">
                  <v-text-field
                    v-model="user.phone"
                    v-mask="'(###) ###-####'"
                    label="Contact Phone number"
                    :rules="phoneRules"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        @click="updatePhone"
                        small
                        outlined
                        text
                        color="primary"
                        :disabled="!phoneValid"
                      >
                        <v-icon left small>phone</v-icon>Update Phone
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-form>
              </v-flex>
              <!-- <v-flex xs12 md4>
                <v-form v-model="emailValid">
                  <v-text-field
                    v-model="user.email"
                    label="Email"
                    :rules="emailRules"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        @click="updateEmail"
                        small
                        outlined
                        text
                        color="primary"
                        :disabled="!emailValid"
                      >
                        <v-icon left small>email</v-icon>Update Email
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-form>
              </v-flex> -->
              <v-flex xs12>
                <p class="cation">
                  If you need to update your email please contact
                  <a href="mailto:app@albademo.com">app@albademo.com</a>
                </p>
              </v-flex>

              <v-flex
                xs12
                v-if="
                  [
                    'luke@albademo.com',
                    'robert@volkindustrial.com',
                    'elvis@albademo.com',
                  ].includes(user.email)
                "
              >
                <v-divider></v-divider>
                <h3 class="mt-4">Quick Order</h3>
                <p>
                  Load your cart with a pre defined set of tools and
                  quantities.<br />
                </p>
                <v-btn color="primary" @click="reloadOrder">Quick Order</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import fb from "@/main";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      emailValid: true,
      phoneValid: true,
      editing: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Contact number required.",
        (v) => v.length == 14 || "Phone must be 10 digits",
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      quickOrderTools: [
        { id: "AlTs8BbIXh9FG0owWlDX", qty: 2 },
        { id: "bUlJ3Cy8LJ7eSwKorEC0", qty: 6 },
        { id: "npOP4PZCDjJTZz4V9GiL", qty: 4 },
        { id: "kfM4hx4tVL9wQxF9xBNz", qty: 4 },
        { id: "3bh1nlCj5agvDkK09u2y", qty: 2 },
        { id: "KmQmcclVu9xp755UGw95", qty: 2 },
        { id: "5CSEh8IxPCEsFE40hDPs", qty: 50 },
        { id: "9MEqyHo4YDSTQCe38jgI", qty: 50 },
        { id: "GdfqjwW68fV2MnLFmjns", qty: 4 },
        { id: "QDGWFcqXYkK9qJ7eKQzC", qty: 4 },
        { id: "OQrBSaOOIpsUy7sFXsCI", qty: 10 },
        { id: "UgBm6Gh4x9pTwEbtuLE7", qty: 1 },
        { id: "P8z6ay2fDPXC96BGKK4R", qty: 80 },
        { id: "VOFt5QzeP6sTlgEFmnnU", qty: 2 },
        { id: "ADuKR8sZ49evJuj89MlZ", qty: 1 },
        { id: "Krc8Ua21kkmjjzuxL4Z1", qty: 1 },
        { id: "PUJj5s9j3Arn3XeL2owA", qty: 1 },
        { id: "FwVl0npTlgx18U0qIu4d", qty: 2 },
        { id: "7CBTXrPCK5rMOKVBgPLH", qty: 2 },
        { id: "myMLvmGYEMAmfrHO6ooQ", qty: 2 },
        { id: "yYSykVmZIKzl3BT6mVfB", qty: 2 },
        { id: "YUkFH0Svj8NT8Jhfgbtf", qty: 1 },
        { id: "5wpUiRqXQJ5fH0blGBcV", qty: 40 },
        { id: "blVO2PKxC1ekJRHdMu7N", qty: 4 },
        { id: "JnY4cNvpYIdeDeZJfZmp", qty: 4 },
        { id: "sH6ovGIUdLfn9Vscc33j", qty: 1 },
        { id: "uwhWOSrI1FxLqlivRh2b", qty: 1 },
        { id: "orRS3axQzI9QWp4kns5S", qty: 4 },
        { id: "31QGggJDhV30WZU1cQiU", qty: 1 },
        { id: "vSFf3YiL6xrHhDI2w8Vq", qty: 2 },
        { id: "JZUCxRwQbwmit2I56jq5", qty: 2 },
        { id: "Svtx9zB1WfLD7npw25fJ", qty: 2 },
        { id: "cW6xv7LqWeUe2mBAiKD0", qty: 2 },
        { id: "40EOfGOkY7m7gLxGlbhh", qty: 1 },
        { id: "ICcJ51zwzYXhjLbSvuzN", qty: 1 },
        { id: "3nULxkmW3hn6NqiprNA0", qty: 1 },
        { id: "iCq4STZ1ieEdKAJvH2q6", qty: 1 },
        { id: "zdlqY5s7eW1dSXB8ITtW", qty: 4 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    signout: async function() {
      try {
        await fb.auth.signOut();
        this.$router.push("/login");
      } catch (error) {
        alert(error);
      }
    },
    async updatePhone() {
      try {
        await fb.db
          .collection("users")
          .doc(this.user.uid)
          .update({
            phone: this.user.phone,
          });
        this.$store.commit("cacheUser", this.user);
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Profile successfully updated!";
      } catch (error) {
        console.log(error);
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating profile.";
      }
    },
    async updateEmail() {
      try {
        await fb.auth.currentUser.updateEmail(this.user.email);
        await fb.db
          .collection("users")
          .doc(this.user.uid)
          .update({
            email: this.user.email,
          });
        this.$store.commit("cacheUser", this.user);
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Profile successfully updated!";
      } catch (error) {
        console.log(error);
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating profile.";
      }
    },
    reloadOrder() {
      this.$store.commit("reloadedOrder", this.quickOrderTools);
      this.$router.push("/tools/cart");
    },
  },
};
</script>
